<script setup lang="ts">
export interface CiLoadingDotsProps {
  size?: 'sm' | 'md' | 'lg';
}
const props = withDefaults(defineProps<CiLoadingDotsProps>(), {
  size: 'md',
});
</script>

<template>
  <div
    :class="`loading-dots--${props.size}`"
    class="loading-dots relative"
  >
    <span class="loading-dots__dot" />
    <span class="loading-dots__dot" />
    <span class="loading-dots__dot" />
  </div>
</template>

<style lang="postcss" scoped>
.loading-dots .loading-dots__dot {
  animation: wave 1.3s linear infinite;
}
.loading-dots .loading-dots__dot:nth-child(2) {
  animation-delay: -1.1s;
}
.loading-dots .loading-dots__dot:nth-child(3) {
  animation-delay: -0.9s;
}

.loading-dots.loading-dots--sm .loading-dots__dot {
  @apply size-2;
}

.loading-dots.loading-dots--md .loading-dots__dot {
  @apply size-3;
}

.loading-dots.loading-dots--lg .loading-dots__dot {
  @apply size-4;
}

@keyframes wave {
  0%,
  60%,
  100% {
    transform: initial;
  }
  30% {
    transform: translateY(-15px);
  }
}
</style>
